import { graphql, useStaticQuery } from "gatsby"

export const useAllStudentStories = (locale) => {
  const { allCosmicjsStudentStories } = useStaticQuery(graphql`
    query {
      allCosmicjsStudentStories {
        edges {
          node {
            id
            slug
            title
            locale
            type
            content
          }
        }
      }
    }
  `)

  const allItems = allCosmicjsStudentStories.edges.map(({ node }, index) => ({
    key: index,
    ...node,
  }))

  if (!locale) {
    return allItems
  }

  return allItems.filter((item) => item.locale === locale)
}
